//misnamed service. should be replace-asset.service.ts

import { Injectable, Inject, Optional, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { AssetDetailService } from "./asset-detail.service";
import { IUser } from "../interface/user";

@Injectable({
  providedIn: "root"
})
export class RetireAssetService {
  // Variables
  private paentAsset;
  private maintId;
  private oldRefParentId;
  private newRefParentId;
  private baseAsset;
  // pending Changes String
  private pendingChanges;
  // Layers
  private signLayer;
  private lightLayer;
  private documentLayer;
  private parentAssetLayer;
  private activityLayer;
  private maintenanceLayer;
  public newAssetObjectId;
  public newAssetObject;
  public oldAaaetId;
  public assessmentlyr;
  // Events
  eventReplaceCompleted: EventEmitter<any>;

  constructor(
    @Inject("FeatureLayer") private FeatureLayer: any,
    @Inject("Graphic") private Graphic: any,
    @Inject("currentUser") private currentUser: IUser,
    @Inject("objGlobals") private objGlobals: any,
    @Inject("objGlobals") private eeService: any,
    @Inject("httpClient") @Optional() private httpClient: any,
    public assetDetailService: AssetDetailService,
    @Inject("GISHttpClient") @Optional() private GISHttpClient: any,
  ) {
    this.FeatureLayer = FeatureLayer;
    this.Graphic = Graphic;
    this.currentUser = currentUser;
    this.objGlobals = objGlobals;
    this.GISHttpClient = GISHttpClient;
    try {
      this.activityLayer = new FeatureLayer(this.currentUser.webServiceURL + "FeatureServer/" + this.currentUser.tableIds.activityId);
      this.maintenanceLayer = new FeatureLayer(this.currentUser.webServiceURL + "FeatureServer/" + this.currentUser.tableIds.maintenanceId);
      this.signLayer = new FeatureLayer(this.currentUser.webServiceURL + "FeatureServer/" + this.currentUser.tableIds.signId);
      this.lightLayer = new FeatureLayer(this.currentUser.webServiceURL + "FeatureServer/" + this.currentUser.tableIds.lightId);
      this.documentLayer = new FeatureLayer(this.currentUser.webServiceURL + "FeatureServer/" + this.currentUser.tableIds.documentId);
      this.assessmentlyr = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.assessmentId, { outFields: ["*"] });
    } catch (error) {
      console.log(error);
    }

    this.eventReplaceCompleted = new EventEmitter<any>();
  }
  updateReplacedAssetStatus(layer, asset, replaceTaskAttributes) {
    try {
      this.oldAaaetId = asset[0].AssetID;
      this.baseAsset = asset;
      this.paentAsset = asset[2];
      this.parentAssetLayer = layer;
      this.pendingChanges = JSON.stringify(this.baseAsset[2].attributes);

      // update (retire) replaced asset
      const attr = asset[2].attributes;
      this.oldRefParentId = attr.AssetID;
      attr.Status = "Inactive";
      attr.RetireDate = new Date(Date.now()).getTime();
      attr.LastModifyDate = new Date(Date.now()).getTime();
      attr.ModifiedBy = this.currentUser.username;
      asset[2].attributes = attr;
      layer.lyrObj = layer; // ?
      const assetId = asset[2].attributes.AssetID;

      this.updateAsset(layer, asset[2]).then((result) => {
        this.addAsset(this.parentAssetLayer, this.paentAsset).then((result) => {
          if (result) {
            asset[2].attributes.InstallDate = new Date(Date.now()).getTime();
            const replaceYear = this.eeService.getCalculatedReplaceYear(asset[1].lyrObj.name, asset[2]);
            const objectId = result[0].objectId;
            //Jira Id-935
            const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === asset[1].name)[0].attributes.LayerCode;

            attr.OBJECTID = objectId;
            attr.AssetID = prefix + "_" + objectId;
            this.newRefParentId = prefix + "_" + objectId;
            this.newAssetObject = objectId;
            attr.Status = "Active";
            attr.ReplacesID = assetId;
            attr.ReplaceYear = replaceYear;
            attr.Latitude = asset[2].attributes.Latitude;
            attr.Longitude = asset[2].attributes.Longitude;
            attr.InstallDate = new Date(Date.now()).getTime();
            attr.RetireDate = null;
            attr.Condition = "Good";
            asset[2].attributes = attr;
            //
            this.updateAsset(asset[1].lyrObj, asset[2]).then((result) => {
              this.updateParenIdForRelatedAssets();
              // *   Create New Task on newly created Asset *
              this.createNewTask(asset[2], replaceTaskAttributes);
            });
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
  }
  private updateParenIdForRelatedAssets() {
    if (this.baseAsset[1].name.includes("Support")) {
      this.getFilteredFeatures(this.currentUser.tableIds.signId, "ParentID", this.oldRefParentId).subscribe((signData) => {
        console.log(signData);
        for (let index = 0; index < signData.features.length; index++) {
          if (signData.features[index].attributes.Status != 'Inactive') {
            const featuresUpdate = new this.Graphic();
            featuresUpdate.setAttributes({
              OBJECTID: signData.features[index].attributes.OBJECTID, 
              ParentID: this.newRefParentId,
              LastModifyDate : new Date(Date.now()).getTime(),
              ModifiedBy : this.currentUser.username
            });
            this.updateAsset(this.signLayer, featuresUpdate);
          }
        }
      });
      this.getFilteredFeatures(this.currentUser.tableIds.lightId, "ParentID", this.oldRefParentId).subscribe((lightData) => {
        console.log(lightData);
        for (let index = 0; index < lightData.features.length; index++) {
          if (lightData.features[index].attributes.Status != 'Inactive') {
            const featuresUpdate = new this.Graphic();
            featuresUpdate.setAttributes({ 
              OBJECTID: lightData.features[index].attributes.OBJECTID, 
              ParentID: this.newRefParentId,
              LastModifyDate : new Date(Date.now()).getTime(),
              ModifiedBy : this.currentUser.username
            });
            this.updateAsset(this.lightLayer, featuresUpdate);
          }
        }
      });
    }

    // As per Jeff comments documents are not required to link with new replaced asset
    // this.getFilteredFeatures(this.currentUser.tableIds.lightId, "ParentID", this.oldRefParentId).subscribe((documentData) => {
    //   console.log(documentData);
    //   for (let index = 0; index < documentData.features.length; index++) {
    //     const featuresUpdate = new this.Graphic();
    //     featuresUpdate.setAttributes({ OBJECTID: documentData.features[index].attributes.OBJECTID, ParentID:  this.newRefParentId });
    //     this.updateAsset(this.signLayer, featuresUpdate);
    //   }
    // });
  }
  // Create New Task
  private createNewTask(asset, replaceTaskAttributes) {
    const featurese = [];

    console.log("test here");
    console.log(replaceTaskAttributes);
    const features = new this.Graphic();
    let assetId;
    if (asset && asset.attributes.AssetID) {
      assetId = asset.attributes.AssetID;
    }
    let geomString;
    if (asset.geometry) {
      if (asset && asset.geometry != null) {
        geomString = asset.geometry.toJson();
      }
      if (geomString.paths) {
        geomString.x = geomString.paths[0][0][0];
        geomString.y = geomString.paths[0][0][1];
        delete geomString.paths;
      }
    } else {
      geomString = replaceTaskAttributes.GeomWKT;  // TSDRSAM-3114
    }

    console.log(".........................test Here..............................");
    // AssetName:this.layerName

    features.setAttributes({
      Status: "Closed",
      CreatedBy: this.currentUser.username,
      CompletedBy: this.currentUser.username,
      CompletionDate: new Date(Date.now()).getTime(),
      CreationDate: new Date(Date.now()).getTime(),
      LastModifyDate : new Date(Date.now()).getTime(),
      ModifiedBy : this.currentUser.username,
      AssetName: asset._layer.name,
      Region: asset.attributes.Region1,                // is this right? should be all 4 regions?
      AssetID: assetId,
      Comment: "Replaced " + this.oldAaaetId,
      GeomWKT: JSON.stringify(geomString),

      // need to uncomment once restore task defects are fixed .
      // PendingChanges: this.pendingChanges
      Worker: replaceTaskAttributes.Worker,
      WorkOrder: replaceTaskAttributes.WorkOrder,
      WorkOrderDesc: replaceTaskAttributes.WorkOrderDesc
    });
    featurese.push(features);         ///// why?????? not used

    this.addAsset(this.maintenanceLayer, features).then((newTask) => {
      this.updateTaskMaintID(newTask);
    });
  }
  private updateTaskMaintID(newTask) {
    const featuresUpdate = new this.Graphic();
    this.maintId = "MNT_" + newTask[0].objectId;
    featuresUpdate.setAttributes({ 
      OBJECTID: newTask[0].objectId, 
      MaintID: "MNT_" + newTask[0].objectId 
    });

    this.updateAsset(this.maintenanceLayer, featuresUpdate).then(() => {
      this.createActivity();
    });
  }
  private createActivity() {
    const actfeatures = new this.Graphic();
    actfeatures.setAttributes({ 
      MaintID: this.maintId, 
      Asset: 0,                   /// should be 0 for support, 1 for sign?? what about other asset classes?  field is obsolete?
      Activity: "New", 
      ModifiedBy: this.currentUser.username 
    });
    this.addAsset(this.activityLayer, actfeatures).then(() => {
      this.updateGlobalObjects();
    });
  }

  private updateAsset(layer, asset) {
    let promise;
    if (layer) {
      promise = new Promise((resolve) => {
        layer
          .applyEdits(null, [asset], null)
          .then((results) => {
            resolve(results);
          })
          .catch(function (error) {
            console.error("[ update applyEdits ] FAILURE: ", error.code, error.name, error.message);
            console.log("error = ", error);
          });
      });
    }
    return promise;
  }

  private addAsset(layer, asset) {        // misnamed. is used to insert maintenance records as well as assets. if remove the errors/unreferenced is very generic method
    let promise;
    if (layer) {
      promise = new Promise((resolve) => {
        layer
          .applyEdits([asset], null, null)
          .then((results) => {
            console.log("newww addedddd" + results);
            if (layer.name == "Sign" || layer.name == "Light") {   
              this.newAssetObjectId = results[0].objectId;              //not referenced
              this.objGlobals.newAssetObjectId = this.newAssetObjectId; //not referenced
            }
            this.newAssessment(results[0].objectId, layer.name);
            resolve(results);
          })
          .catch(function (error) {
            console.error("[ update applyEdits ] FAILURE: ", error.code, error.name, error.message);
            console.log("error = ", error);
          });
      });
    }
    return promise;
  }
  private deleteAsset(layer, asset) {
    let promise;
    if (layer) {
      promise = new Promise((resolve) => {
        layer.applyEdits(null, null, [asset]).then((results) => {
          resolve(results);
        });
      });
    }
    return promise;
  }
  // Get Asset Code
  private getAssetIDFormat(layername) {
    const assetFormatCodes = [
      { key: "Barrier", value: "BAR" },
      { key: "CrashCushion", value: "CCU" },
      { key: "EndTreatment", value: "ETM" },
      { key: "Guardrail", value: "GUR" },
      { key: "PavementMarking", value: "PVM" },
      { key: "PavementMarking_Symbol", value: "PVS" },
      { key: "Support", value: "SUP" },
      { key: "Sign", value: "SIG" },
      { key: "Light", value: "LGT" }
    ];
    return assetFormatCodes.filter((prefix) => prefix.key === layername);
  }

  // Update Global Objects
  private updateGlobalObjects() {
    //if (this.objGlobals.complaintID != null && this.objGlobals.complaintID !== undefined && this.objGlobals.complaintID !== "") {
    if (this.objGlobals.complaintID && this.objGlobals.complaintID !== "") {
      //(this.objGlobals.longitude = this.paentAsset.attributes.Longitude), (this.objGlobals.latitude = this.paentAsset.attributes.Latitude), (this.objGlobals.assetID = this.newRefParentId);
      this.objGlobals.longitude = this.paentAsset.attributes.Longitude;
      this.objGlobals.latitude = this.paentAsset.attributes.Latitude;
      this.objGlobals.assetID = this.newRefParentId;
    }
    this.eventReplaceCompleted.emit([this.newAssetObject, this.newRefParentId]);
  }
  // get Data   ----   11/1/25 jcc todo use method from genericlayer.service instead of likely duplication
  private getFilteredFeatures(lyrId: number, fieldName: string, value: string) {
    const urlfilterFeatures = environment.queryAllPostFixGeomFalse.replace("1=1", fieldName + "='" + value + "'");
    return this.GISHttpClient.get(environment.proxy + this.currentUser.webServiceURL + environment.featureServer + lyrId + urlfilterFeatures);
  }
  newAssessment(newAssetid, layerName) {
    console.log("assetment");
    //Jira Id-935
    const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === layerName)[0].attributes.LayerCode;

    if (prefix) {
      const features = new this.Graphic();
      const assetAttr: any = [];
      assetAttr.AssetID = prefix + "_" + newAssetid;
      assetAttr.Condition = "Good";
      assetAttr.Inspector = this.currentUser.username;
      assetAttr.InspectionDate = new Date(Date.now()).getTime();
      assetAttr.AssessType = "System Generated";
      assetAttr.ModifiedBy = this.currentUser.username;
      assetAttr.LastModifyDate = new Date(Date.now()).getTime();
      features.setAttributes(assetAttr);
      this.assessmentlyr.applyEdits(
        [features],
        null,
        null,
        (evt) => {
          const upfeatures = new this.Graphic();
          const upassetAttr: any = [];
          upassetAttr.OBJECTID = evt[0].objectId;
          upassetAttr.AssessmentID = evt[0].objectId;
          upfeatures.setAttributes(upassetAttr);
          this.assessmentlyr.applyEdits(null, [upfeatures], null);
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
}
